// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--11g0Q","content":"content--WYsOs contentWrapper--AHarZ","title":"title--1mEMD title--3f9JQ","detail":"detail--2276Y contentArea--SiMDT","section":"section--2jrbm","presenter":"presenter--3LDR6","mainContent":"mainContent--34Glr","videoWrapper":"videoWrapper--3Mln8","video":"video--fTdZw","bios":"bios--1lO1W","bio":"bio--2NQfg","bioNames":"bioNames--1Xiop","field":"field--3Ytbd field--3-Kdn","fieldLabel":"fieldLabel--3tt_R calderDark--1bp9m","bioName":"bioName--1WOpZ calderDark--1bp9m","lightText":"lightText--1cYAA calderLC--1nri-"};


//////////////////
// WEBPACK FOOTER
// ./components/SessionIndividual/styles.css
// module id = 1040
// module chunks = 2